if (!customElements.get('tab-component')) {
  class TabComponent extends HTMLElement {
    constructor() {
      super();

      const tabs = this.querySelectorAll('[role="tab"]');
      const tabList = this.querySelector('[role="tablist"]');
      const tabListElements = this.querySelectorAll('.tabbed-content-tab');
      // Check if tabListElements is not empty before moving elements inside the tabList
      if (tabListElements.length > 0) {
        tabListElements.forEach((element) => {
          tabList.appendChild(element);
        });
      }
      // Add a click event handler to each tab
      tabs.forEach((tab) => {
        tab.addEventListener('click', this.changeTabs);
      });

      // Enable arrow navigation between tabs in the tab list
      let tabFocus = 0;

      tabList.addEventListener('keydown', (e) => {
        // Move right
        if (e.keyCode === 39 || e.keyCode === 37) {
          tabs[tabFocus].setAttribute('tabindex', -1);
          if (e.keyCode === 39) {
            tabFocus++;
            // If we're at the end, go to the start
            if (tabFocus >= tabs.length) {
              tabFocus = 0;
            }
            // Move left
          } else if (e.keyCode === 37) {
            tabFocus--;
            // If we're at the start, move to the end
            if (tabFocus < 0) {
              tabFocus = tabs.length - 1;
            }
          }

          tabs[tabFocus].setAttribute('tabindex', 0);
          tabs[tabFocus].focus();
        }
      });
    }

    changeTabs(e) {
      const target = e.target;
      const parent = target.parentNode;
      const tabComponent = target.closest('tab-component');

      // Remove all current selected tabs
      parent
        .querySelectorAll('[aria-selected="true"]')
        .forEach((t) => t.setAttribute("aria-selected", false));

      // Set this tab as selected
      target.setAttribute("aria-selected", true);

      // Hide all tab panels
      tabComponent
        .querySelectorAll('[role="tabpanel"]:not([aria-roledescription="slide"]')
        .forEach((p) => p.setAttribute("hidden", true));

      // Show the selected panel
      tabComponent.parentNode
        .querySelector(`#${target.getAttribute("aria-controls")}`)
        .removeAttribute("hidden");
    }
  }

  customElements.define('tab-component', TabComponent);
}